import React from "react";
import { Box, Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import Keywords from "./Keywords";
function AddKeywords({ preloadedData, control }) {
  return (
    <>
      <Box display={"flex"} alignItems={"center"} gap={1}>
        <h3>Add Keywords</h3>
        <Tooltip
          title={
            "Relevant keywords significantly improve the visibility of your job post on Google Search, making it easier for potential candidates to find and apply for your position."
          }
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: ".9rem",
                bgcolor: "#658f9f",
                color: "white"
              }
            }
          }}
        >
          <InfoOutlined sx={{ color: "gray" }} />
        </Tooltip>
      </Box>
      <Box mb={2}>
        <Keywords
          defaultValue={preloadedData?.jp_keywords}
          control={control}
          name={"jp_keywords"}
          label={"Add keywords (Type your keyword and press enter) *"}
          rules={{ required: "Keywords is required" }}
        />
      </Box>
    </>
  );
}

export default AddKeywords;
